<script setup lang="ts">
import { toRef, ref, computed, watchEffect } from 'vue'
import _ from 'lodash'

export type GameMaturityRating = {
  maturity_rating_id: number | null,
  component_id: number
}

export type MaturityRating = {
  id: number,
  name: string,
  maturity_rating_system_id: number,
  age_from: number
}

export type MaturityRatingSystem = {
  id: number,
  name: string
}
const props = defineProps<{
  maturity_ratings: MaturityRating[],
  maturity_rating_systems: MaturityRatingSystem[],
  game_maturity_rating: GameMaturityRating,
  index: number
}>()

const { maturity_rating_systems, maturity_ratings } = props
const game_maturity_rating = toRef(props, 'game_maturity_rating')

const selectedMaturityRatingSystemId = ref<number>()

watchEffect(
  () => {
    const mrId = props.game_maturity_rating.maturity_rating_id
    if(!mrId) { return }

    selectedMaturityRatingSystemId.value =
      maturity_ratings.find(mr => mr.id === mrId)?.maturity_rating_system_id
  }
)

const emit = defineEmits(['update:game_maturity_rating', 'delete-rating'])

const selectableMaturityRating = computed(() => {
  if(!selectedMaturityRatingSystemId.value) { return }

  const groupedMaturityRating = _.groupBy(maturity_ratings, 'maturity_rating_system_id')
  return groupedMaturityRating[selectedMaturityRatingSystemId.value]
})

const updateMaturityRatingId = (e: any) => {
  emit('update:game_maturity_rating', {
    ...game_maturity_rating.value,
    maturity_rating_id: parseInt(e.target.value)
  })
}
const deleteGameMaturityRating = () => {
  emit('delete-rating', props.game_maturity_rating.component_id)
}

</script>
<template lang="pug">
div.games__modal-basic-item(class="uk-flex uk-flex-middle")
  select.games__modal-basic-associations(class="uk-select" v-model="selectedMaturityRatingSystemId")
    option
    option(v-for="system in maturity_rating_systems" :value="system.id" )
      | {{ $t(`js.maturity_rating_systems.maturity_rating_system/name.${system.name}`) }}
  select.games__modal-basic-classes(
    class="uk-select"
    :disabled="!selectedMaturityRatingSystemId"
    v-bind:value="game_maturity_rating?.maturity_rating_id"
    @input="updateMaturityRatingId"
  )
    option
    option(v-for="rating in selectableMaturityRating" :value="rating.id")
      | {{ $t(`js.maturity_ratings.maturity_rating/name.${rating.name}`) }}（{{ rating.age_from }}+）
  div.games__modal-basic-remove(v-if="index !== 0" @click="deleteGameMaturityRating")
    fa(icon="trash-can")
</template>
<i18n lang="json">
</i18n>
